var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnBrandNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.065 4.232a1.324 1.324 0 110-2.648 1.324 1.324 0 010 2.648m12.516 4.03L8.037.717C7.621.302 6.893 0 6.305 0H1.43C.642 0 0 .641 0 1.43v4.876c0 .589.302 1.317.718 1.731l7.544 7.544c.269.27.629.419 1.011.419a1.42 1.42 0 001.011-.418l5.297-5.297c.27-.27.419-.629.419-1.012 0-.382-.15-.742-.42-1.011",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgIcnBrandNew;